// extracted by mini-css-extract-plugin
export var avatarStack = "styles-module__avatarStack___cZ8q9";
export var connectionsModal = "styles-module__connectionsModal___vJyiJ";
export var count = "styles-module__count___xQo2B";
export var header = "styles-module__header___JspkR";
export var modalInterior = "styles-module__modalInterior___i3cdF";
export var title = "styles-module__title___KrgjQ";
export var userLabel = "styles-module__userLabel____JSH6";